export default __webpack_public_path__ + "static/media/Clan Bound Straps of Passing Spirits.3030401c.jpg";